import {
  Box,
  Flex,
  Heading,
  Text,
  Badge,
  Stack,
  Button,
  Divider,
  useToast,
  Select,
  Textarea,
  FormControl,
  FormLabel,
  VStack,
  useColorModeValue,
  HStack,
  Icon,
  Spinner,
  useDisclosure,
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  SimpleGrid,
  Avatar,
  Link,
  Tooltip,
  IconButton,
  IconProps,
  Card,
  CardBody,
  Checkbox,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react';
import { ComponentType, useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
  deleteLead,
  getLeadByIdFromLocal,
  updateLeadDetail,
} from '../hooks/leads';
import {
  deleteLeadNote,
  getLeadNotes,
  saveLeadNote,
} from '../hooks/lead_notes';
import {
  EditIcon,
  InfoOutlineIcon,
  CalendarIcon,
  DeleteIcon,
} from '@chakra-ui/icons';
import DateUpdateSelector from '../components/layout/DateUpdateSelector';
import AudioRecorder from '../components/AudioRecorder';
import LeadSuggestions from '../components/LeadSuggestions';
import { EmailIcon, PhoneIcon, TimeIcon } from '@chakra-ui/icons';
import {
  FaUser,
  FaCalendarPlus,
  FaCalendarCheck,
  FaUserPlus,
  FaUserTie,
  FaCheckCircle,
  FaServer,
  FaEye,
} from 'react-icons/fa';
import {
  deleteLeadInterest,
  getLeadInterests,
  saveLeadInterest,
} from '../hooks/lead_interests';
import { ErrorBar } from '../components/ErrorReportBar';
import { CatalogueItem, getCompanyName, Lead, LeadInterest, LeadNote } from '../utils/types';
import { getCustomerFromLead } from '../hooks/customers';
import { createQuote } from '../hooks/customer_quotes';
import { createQuoteItem } from '../hooks/quote_items';
import { getCatalogue, getCatalogueItems } from '../hooks/catalogueItems';
import {
  LeadHero,
  LeadPrimaryButton,
  LeadSectionCard,
  LeadShell,
} from './leads/components/leadsUi';

export default function LeadDetailsPage() {
  const { leadId, orgId } = useParams();
  const [lead, setLead] = useState<Lead>();
  const [loading, setLoading] = useState(true);
  const [note, setNote] = useState('');
  const [customerId, setCustomerId] = useState('');
  const [notes, setNotes] = useState<LeadNote[]>([]);
  const [catalogue, setCatalogue] = useState<CatalogueItem[]>([]);
  const [interests, setInterests] = useState<LeadInterest[]>([]);
  const [error, setError] = useState('');
  const [status, setStatus] = useState('');
  const [interest, setInterest] = useState('');
  const toast = useToast();
  let navigate = useNavigate();
  const [selectedIds, setSelectedIds] = useState<string[]>([]);
  const cancelRef = useRef(null);
  const noteDeleteCancelRef = useRef(null);
  const [noteToDelete, setNoteToDelete] = useState<LeadNote | null>(null);

  const {
    isOpen: isOpenInterest,
    onOpen: onOpenInterest,
    onClose: onCloseInterest,
  } = useDisclosure();

  // For Delete Confirmation popup
  const {
    isOpen: isOpenDelete,
    onOpen: onOpenDelete,
    onClose: onCloseDelete,
  } = useDisclosure();

  const {
    isOpen: isOpenNoteDelete,
    onOpen: onOpenNoteDelete,
    onClose: onCloseNoteDelete,
  } = useDisclosure();

  const cardBg = useColorModeValue('white', 'gray.800');
  const cardShadow = useColorModeValue('sm', 'md');

  useEffect(() => {
    getLeadData();
  }, [orgId, leadId]);

  useEffect(() => {
    loadNotes();
    loadInterests();
  }, [orgId, leadId]);

  const saveInterests = async () => {
    if (selectedIds && orgId && leadId) {
      const responses = await Promise.all(
        selectedIds.map((interest_id) =>
          saveLeadInterest(orgId, leadId, interest_id.toString()),
        ),
      );

      if (responses.some((response) => !response?.success)) {
        setError('An error occurred while saving interests.');
        toast({
          title: 'Could not save interests',
          status: 'error',
          duration: 3000,
          isClosable: true,
        });
        return;
      }

      await getLeadData();
      setSelectedIds([]);
      onCloseInterest();
      toast({
        title: 'Interests saved',
        status: 'success',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const loadInterests = async () => {
    console.log('loadInterests called');
    if (orgId && leadId) {
      let response = await getLeadInterests(orgId, leadId);
      if (!response?.success || !Array.isArray(response.data)) {
        setError('An error occurred loading interests');
        setInterests([]);
        return;
      }
      setInterests(response.data);
      console.log('interests', response.data);
    }
  };

  const generateQuoteRef = () => {
    const datePart = new Date().toISOString().slice(0, 10).replace(/-/g, ''); // YYYYMMDD
    const randomPart = Math.random().toString(36).substring(2, 7).toUpperCase(); // 5 chars
    return `Q-${datePart}-${randomPart}`;
  };

  let randomRef = generateQuoteRef();

  const handleGenerateQuote = async () => {
    let quote_id = '';
    if (orgId && leadId) {
      let response = await getCustomerFromLead(orgId, leadId, null);
      console.log('response', response);
      if (response?.success) {
        setCustomerId(response?.data);
        let quote_response = await createQuote(
          orgId,
          response?.data?.customer_id,
          randomRef,
          'Looking foward to your business.',
          null,
          null,
        );
        if (quote_response) {
          quote_id = quote_response?.data?.id;
          const quote_items = interests.map((interest) => ({
            item_name: interest.interest.name,
            quantity: 1,
            unit_price: interest.interest.price,
          }));

          quote_items.forEach(async (item) => {
            try {
              let cqi_response = await createQuoteItem(
                orgId,
                quote_response.data.id,
                item.item_name,
                item.quantity,
                item.unit_price,
              );
              console.log('cqi_response', cqi_response);
            } catch (error) {
              console.error('Failed to create quotation item', error);
            }
          });
        }
      }
      getLeadData();

      setSelectedIds([]);
      onCloseInterest();
      navigate(`/organization/${orgId}/quotes/${quote_id}`);
    }
  };

  const getLeadData = async () => {
    if (leadId && orgId) {
      const response = await getLeadByIdFromLocal(leadId, orgId);
      await getCatalogueData();

      if (response.success && response.data) {
        setLead(response.data);
        setInterests(response.data?.interests);
        setLoading(false);
        setStatus(response?.data?.stage);
        setInterest(response?.data?.level_of_interest || '');
      } else {
        setError(String(response.data || 'Failed to load lead'));
        setLoading(false);
      }
    }
  };

  const getCatalogueData = async () => {
    if (orgId) {
      const catalogueResponse = await getCatalogue(orgId);
      if (!catalogueResponse.success || !catalogueResponse.data?.id) {
        setCatalogue([]);
        return;
      }

      const response = await getCatalogueItems(orgId, catalogueResponse.data.id);
      if (response.success && response.data) {
        setCatalogue(response.data.results || []);
      } else {
        setError(String(response.data || 'Failed to load catalogue items'));
      }
    }
  };

  const handleUpdateStatus = async () => {
    if (orgId && leadId && status) {
      const response = await updateLeadDetail(orgId, leadId, 'stage', status);
      if (!response?.success) {
        toast({
          title: 'Error updating lead status.',
          description: 'Lead status update error',
          status: 'error',
          duration: 3000,
          isClosable: true,
        });
        return;
      }
      await getLeadData();
      toast({
        title: 'Lead status updated.',
        description: `New stage: ${status}`,
        status: 'success',
        duration: 3000,
        isClosable: true,
      });
    } else {
      toast({
        title: 'Error updating lead status.',
        description: `Lead status update error`,
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const toggleSelect = (id: string) => {
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id],
    );
  };

  const handleDeleteLead = async () => {
    if (orgId && leadId) {
      let response = await deleteLead(orgId, leadId);
      if (response?.success) {
        onCloseDelete();
        toast({
          title: 'Success',
          description: `Lead deleted`,
          status: 'success',
          duration: 3000,
          isClosable: true,
        });
        navigate(-1);
      } else {
        toast({
          title: 'Error deleting lead.',
          description: `Lead delete error`,
          status: 'error',
          duration: 3000,
          isClosable: true,
        });
      }
    }
  };

  const handleDeleteNote = async (noteId: any) => {
    if (orgId && leadId) {
      let response = await deleteLeadNote(orgId, leadId, noteId);
      if (response?.success) {
        onCloseNoteDelete();
        setNoteToDelete(null);
        toast({
          title: 'Success',
          description: `Lead Note deleted`,
          status: 'success',
          duration: 3000,
          isClosable: true,
        });
        await loadNotes();
      } else {
        toast({
          title: 'Error deleting lead.',
          description: `Lead Note delete error`,
          status: 'error',
          duration: 3000,
          isClosable: true,
        });
      }
    }
  };

  const handleDeleteInterest = async (interestId: any) => {
    if (orgId && leadId) {
      let response = await deleteLeadInterest(orgId, leadId, interestId);
      if (response?.success) {
        toast({
          title: 'Success',
          description: `Lead Interest deleted`,
          status: 'success',
          duration: 3000,
          isClosable: true,
        });
        await getLeadData();
        await loadInterests();
      } else {
        toast({
          title: 'Error deleting lead interest.',
          description: `Lead Interest delete error`,
          status: 'error',
          duration: 3000,
          isClosable: true,
        });
      }
    }
  };

  const handleUpdateInterest = async () => {
    if (orgId && leadId && interest) {
      const response = await updateLeadDetail(
        orgId,
        leadId,
        'level_of_interest',
        interest,
      );
      if (!response?.success) {
        toast({
          title: 'Error updating lead interest.',
          description: 'Lead interest update error',
          status: 'error',
          duration: 3000,
          isClosable: true,
        });
        return;
      }
      await getLeadData();
      toast({
        title: 'Lead interest level updated.',
        description: `Updated to ${interest}`,
        status: 'success',
        duration: 3000,
        isClosable: true,
      });
    } else {
      toast({
        title: 'Error updating lead interest.',
        description: `Lead interest update error`,
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const handleAddVoiceTranscribedNote = async (note: string) => {
    const trimmedNote = note.trim();
    if (orgId && leadId && trimmedNote) {
      const response = await saveLeadNote(orgId, leadId, trimmedNote);
      if (!response?.success) {
        toast({
          title: 'Error adding note to lead.',
          description: 'Your note has not been saved.',
          status: 'error',
          duration: 3000,
          isClosable: true,
        });
        return;
      }
      await getLeadData();
      await loadNotes();
      toast({
        title: 'Note added to lead.',
        description: 'Your note has been saved.',
        status: 'success',
        duration: 3000,
        isClosable: true,
      });
      setNote('');
    } else {
      toast({
        title: 'Error adding note to lead.',
        description: 'Your note has not been saved.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const handleAddNote = async () => {
    const trimmedNote = note.trim();
    if (orgId && leadId && trimmedNote) {
      const response = await saveLeadNote(orgId, leadId, trimmedNote);
      if (!response?.success) {
        toast({
          title: 'Error adding note to lead.',
          description: 'Your note has not been saved.',
          status: 'error',
          duration: 3000,
          isClosable: true,
        });
        return;
      }
      await getLeadData();
      await loadNotes();
      toast({
        title: 'Note added to lead.',
        description: 'Your note has been saved.',
        status: 'success',
        duration: 3000,
        isClosable: true,
      });
      setNote('');
    } else {
      toast({
        title: 'Error adding note to lead.',
        description: 'Your note has not been saved.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const loadNotes = async () => {
    if (orgId && leadId) {
      const response = await getLeadNotes(orgId, leadId);
      if (!response?.success || !Array.isArray(response.data)) {
        setNotes([]);
        toast({
          title: 'Error',
          description: 'Error loading lead notes.',
          status: 'error',
          duration: 3000,
          isClosable: true,
        });
        return;
      }
      setNotes(response.data);
      console.log('notes', response.data);
    } else {
      toast({
        title: 'Error',
        description: 'Error loading lead notes.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const handleAddInterest = async (interest_id: string) => {
    if (orgId && leadId && interest_id) {
      const response = await saveLeadInterest(orgId, leadId, interest_id);
      if (!response?.success) {
        toast({
          title: 'Error adding interest to lead.',
          description: 'Lead Interest has not been saved.',
          status: 'error',
          duration: 3000,
          isClosable: true,
        });
        return;
      }
      await getLeadData();
      await loadInterests();
      toast({
        title: 'Interest added to lead.',
        description: 'Lead Interest has been saved.',
        status: 'success',
        duration: 3000,
        isClosable: true,
      });
    } else {
      toast({
        title: 'Error adding interest to lead.',
        description: 'Lead Interest has not been saved.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const requestDeleteNote = (currentNote: LeadNote) => {
    setNoteToDelete(currentNote);
    onOpenNoteDelete();
  };

  const labelColor = '#006400';

  const InfoText = ({ label, value }: { label: string; value?: string }) => {
    if (!value) return null;
    return (
      <Text>
        <Text as="span" fontWeight="semibold" color={labelColor}>
          {label}:{' '}
        </Text>
        {value}
      </Text>
    );
  };

  return (
    <LeadShell compact>
      {error && <ErrorBar message={error} />}
      <LeadHero
        title={
          `${lead?.title ?? ''} ${lead?.first_name ?? ''} ${lead?.second_name ?? ''}`.trim() ||
          'Lead details'
        }
        description="View lead information, update status and follow-up dates, manage interests, and keep notes in one place."
        primaryAction={
          <LeadPrimaryButton
            leftIcon={<EditIcon />}
            onClick={() => navigate(`/organization/${orgId}/leads/${leadId}/edit`)}
          >
            Edit Lead
          </LeadPrimaryButton>
        }
        secondaryAction={
          <Button
            leftIcon={<DeleteIcon />}
            colorScheme="red"
            variant="outline"
            borderRadius="16px"
            onClick={onOpenDelete}
          >
            Delete
          </Button>
        }
      />

      {/* Confirm Delete Dialog */}
      <AlertDialog
        isOpen={isOpenDelete}
        leastDestructiveRef={cancelRef}
        onClose={onCloseDelete}
        isCentered
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Confirm Deletion
            </AlertDialogHeader>
            <AlertDialogBody>
              Are you sure you want to delete this lead? This action cannot be
              undone.
            </AlertDialogBody>
            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onCloseDelete}>
                Cancel
              </Button>
              <Button
                colorScheme="red"
                onClick={handleDeleteLead}
                ml={3}
                isLoading={loading}
              >
                Delete
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>

      {/* Dashboard Grid */}
      <SimpleGrid columns={{ base: 1, md: 2 }} spacing={6}>
        <LeadSectionCard
          title="Lead information"
          description="Contact details, ownership, and timeline highlights."
        >
          <Box
            w="100%"
            p={4}
            borderWidth="1px"
            borderRadius="lg"
            boxShadow="sm"
            bg="gray.50"
            mb={6}
          >
            <HStack spacing={4} align="center">
              <Avatar
                name={[lead?.first_name, lead?.second_name]
                  .filter(Boolean)
                  .join(' ')}
                bg="green.500"
                color="white"
                size="lg"
              />
              <Box>
                <Text fontSize="lg" fontWeight="bold" color="gray.800">
                  {[lead?.title, lead?.first_name, lead?.second_name]
                    .filter(Boolean)
                    .join(' ')}
                </Text>
                <HStack spacing={1}>
                  <EmailIcon color="gray.500" />
                  {lead?.email ? (
                    <Link
                      href={`mailto:${lead.email}`}
                      color="blue.500"
                      fontSize="sm"
                      isExternal
                    >
                      {lead.email}
                    </Link>
                  ) : (
                    <Text fontSize="sm" color="gray.500">
                      No email provided
                    </Text>
                  )}
                </HStack>

                <HStack spacing={1}>
                  <PhoneIcon color="gray.500" />
                  {lead?.phone ? (
                    <Link
                      href={`tel:${lead.phone}`}
                      color="blue.500"
                      fontSize="sm"
                    >
                      {lead.phone}
                    </Link>
                  ) : (
                    <Text fontSize="sm" color="gray.500">
                      No phone provided
                    </Text>
                  )}
                </HStack>
              </Box>
            </HStack>
          </Box>

          <VStack align="start" spacing={4}>
            <HStack>
              {/* <FaCalendarPlus color="gray" /> */}
              <Icon
                as={FaCalendarPlus as ComponentType<IconProps>}
                color="gray.500"
                boxSize={4}
              />

              <InfoText
                label="Added On"
                value={
                  lead?.created_at
                    ? new Date(lead.created_at).toLocaleString(undefined, {
                        dateStyle: 'medium',
                        timeStyle: 'short',
                      })
                    : 'N/A'
                }
              />
            </HStack>

            {lead?.company && (
              <HStack>
                <Icon
                  as={FaServer as ComponentType<IconProps>}
                  color="gray.500"
                  boxSize={4}
                />
                <InfoText label="Related Company" value={''} />
                <Text
                  textDecoration={'underline'}
                  onClick={() => {
                    navigate(`/organization/${orgId}/manage-companies`);
                  }}
                >
                  {getCompanyName(lead?.company)}
                </Text>
              </HStack>
            )}
            {lead?.last_contacted && (
              <HStack>
                <Icon
                  as={FaCalendarCheck as ComponentType<IconProps>}
                  color="gray.500"
                  boxSize={4}
                />
                <InfoText
                  label="Last Contacted"
                  value={new Date(lead.last_contacted).toLocaleString(
                    undefined,
                    { dateStyle: 'medium', timeStyle: 'short' },
                  )}
                />
              </HStack>
            )}

            {lead?.next_follow_up && (
              <HStack>
                <TimeIcon color="gray.500" />
                <InfoText
                  label="Next Follow-up"
                  value={new Date(lead.next_follow_up).toLocaleString(
                    undefined,
                    { dateStyle: 'medium', timeStyle: 'short' },
                  )}
                />
              </HStack>
            )}

            {lead?.added_by && (
              <HStack>
                {/* <FaUserPlus color="gray" /> */}
                <Icon
                  as={FaUserPlus as ComponentType<IconProps>}
                  color="gray.500"
                  boxSize={4}
                />
                <InfoText label="Added by" value={lead?.added_by} />
              </HStack>
            )}

            {lead?.name_of_employee_assigned_to && (
              <HStack>
                <Icon
                  as={FaUserTie as ComponentType<IconProps>}
                  color="gray.500"
                  boxSize={4}
                />
                <InfoText
                  label="Assigned to"
                  value={lead?.name_of_employee_assigned_to}
                />
              </HStack>
            )}

            {status && (
              <HStack>
                {/* <FaCheckCircle color="gray" /> */}
                <Icon
                  as={FaCheckCircle as ComponentType<IconProps>}
                  color="gray.500"
                  boxSize={4}
                />
                <Text fontWeight="semibold">Status:</Text>
                <Badge bg={labelColor} color="white" px={3} py={1} rounded="md">
                  {status.toUpperCase()}
                </Badge>
              </HStack>
            )}
          </VStack>

          {leadId && orgId && lead && (
            <LeadSuggestions lead={lead} leadId={leadId} orgId={orgId} />
          )}
        </LeadSectionCard>

        {/* Status & Interest Panel */}
        <LeadSectionCard
          title="Status and follow-up"
          description="Keep the lead moving by updating status, interest, and follow-up dates."
        >
          <VStack spacing={6} align="stretch">
            <FormControl>
              <FormLabel color={labelColor}>Update Status</FormLabel>
              <HStack spacing={4}>
                <Select
                  value={status}
                  onChange={(e) => setStatus(e.target.value)}
                  borderColor="green.600"
                  flex="1"
                >
                  <option value="">Select</option>
                  <option value="new">New</option>
                  <option value="contacted">Contacted</option>
                  <option value="qualified">Qualified</option>
                  <option value="proposal">Proposal</option>
                  <option value="won">Won</option>
                  <option value="lost">Lost</option>
                </Select>
                <Button
                  colorScheme="green"
                  bg="#006400"
                  onClick={handleUpdateStatus}
                  w="150px"
                >
                  Save Status
                </Button>
              </HStack>
            </FormControl>

            <FormControl>
              <FormLabel color={labelColor}>Update Interest</FormLabel>
              <HStack spacing={4}>
                <Select
                  value={interest}
                  onChange={(e) => setInterest(e.target.value)}
                  borderColor="green.600"
                  flex="1"
                >
                  <option value="">Select</option>
                  <option value="HIGHLY">Highly Interested</option>
                  <option value="MEDIUM_INTEREST">Medium Interest</option>
                  <option value="INTERESTED">Interested</option>
                  <option value="NEUTRAL">Neutral</option>
                  <option value="NOT_INTERESTED">Not Interested</option>
                </Select>
                <Button
                  colorScheme="green"
                  bg="#006400"
                  onClick={handleUpdateInterest}
                  w="150px"
                >
                  Save Interest
                </Button>
              </HStack>
            </FormControl>

            <Divider />

            <FormLabel color="green.700">Last Contacted</FormLabel>
            <DateUpdateSelector
              initialDate={new Date('2025-06-01T12:00:00')}
              onSave={async (date) => {
                if (orgId) {
                  await updateLeadDetail(
                    orgId,
                    leadId,
                    'last_contacted',
                    date.toISOString(),
                  );
                  getLeadData();
                }
              }}
            />

            <FormLabel color="green.700">Next Follow Up</FormLabel>
            <DateUpdateSelector
              initialDate={new Date('2025-06-01T12:00:00')}
              onSave={async (date) => {
                if (orgId) {
                  await updateLeadDetail(
                    orgId,
                    leadId,
                    'next_follow_up',
                    date.toISOString(),
                  );
                  getLeadData();
                }
              }}
            />
          </VStack>
        </LeadSectionCard>

        {/* Interests */}
        <LeadSectionCard
          title="Interests"
          description="Track the products this lead is interested in and create a quote when ready."
          action={
            <Button
              size="sm"
              colorScheme="green"
              bg="#006400"
              onClick={onOpenInterest}
            >
              Add Interest
            </Button>
          }
        >
          <HStack justify="space-between" mb={4}>
            <Box />
          </HStack>
          <HStack spacing={4} flexWrap="wrap" align="stretch">
            {interests?.map((interest) => (
              <Card
                key={interest.id}
                w="150px"
                rounded="xl"
                shadow="md"
                _hover={{ shadow: 'xl', transform: 'scale(1.02)' }}
                transition="all 0.2s"
              >
                <CardBody>
                  <VStack spacing={3} align="center">
                    <Text fontWeight="semibold" fontSize="md">
                      {interest?.interest?.name}
                    </Text>
                    <Text fontSize="sm" color="gray.600">
                      USD${interest?.interest.price}
                    </Text>
                    <Button
                      size="sm"
                      colorScheme="red"
                      variant="outline"
                      onClick={() => handleDeleteInterest(interest.id)}
                    >
                      Delete
                    </Button>
                  </VStack>
                </CardBody>
              </Card>
            ))}
          </HStack>
          {interests && interests?.length > 0 && (
            <Button
              alignSelf={'center'}
              mt={10}
              size="sm"
              colorScheme="green"
              bg={'#006400'}
              onClick={() => {
                handleGenerateQuote();
              }}
            >
              Generate Quotation
            </Button>
          )}
          <Modal isOpen={isOpenInterest} onClose={onCloseInterest} size="lg">
            <ModalOverlay />
            <ModalContent rounded="2xl">
              <ModalHeader>Select Interests</ModalHeader>
              <ModalCloseButton />
              <ModalBody>
                <Stack spacing={3}>
                  {catalogue.map((item) => (
                    <Checkbox
                      key={item.id}
                      isChecked={selectedIds.includes(item.id.toString())}
                      onChange={() => toggleSelect(item.id.toString())}
                    >
                      {item.name} – ${item.price}
                    </Checkbox>
                  ))}
                </Stack>
              </ModalBody>
              <ModalFooter>
                <Button variant="ghost" mr={3} onClick={onCloseInterest}>
                  Cancel
                </Button>
                <Button
                  colorScheme="green"
                  bg={'#006400'}
                  onClick={saveInterests}
                >
                  Save Interests
                </Button>
              </ModalFooter>
            </ModalContent>
          </Modal>
        </LeadSectionCard>

        {/* Notes Panel */}
        <LeadSectionCard
          title="Add note"
          description="Capture important context from calls, meetings, and follow-ups."
        >
          <FormControl>
            <FormLabel color={labelColor}>New Note</FormLabel>
            <Textarea
              value={note}
              onChange={(e) => setNote(e.target.value)}
              placeholder="Add notes from recent conversations..."
              mb={3}
            />
            <Button
              mt={2}
              bg="green.700"
              color="white"
              _hover={{ bg: 'green.800' }}
              onClick={handleAddNote}
            >
              Save Note
            </Button>
          </FormControl>

          <AudioRecorder
            isNotes={true}
            onSaveNote={handleAddVoiceTranscribedNote}
          />
        </LeadSectionCard>

        {/* Lead Notes List Panel */}
        <Box gridColumn={{ md: 'span 2' }}>
          <LeadSectionCard
            title="Lead notes"
            description="Review the latest notes first and keep recent activity easy to scan."
          >
          {loading ? (
            <Spinner size="lg" color="green.500" />
          ) : (
            <VStack spacing={4} align="stretch">
              {notes && notes?.length === 0 ? (
                <Text>No notes available.</Text>
              ) : (
                notes &&
                notes.length > 0 &&
                notes
                  .sort(
                    (a, b) =>
                      new Date(b.created_at).getTime() -
                      new Date(a.created_at).getTime(),
                  )
                  .map((note) => (
                    <Box
                      key={note.id}
                      bg={cardBg}
                      p={4}
                      rounded="xl"
                      shadow={cardShadow}
                      borderLeft="5px solid #006400"
                      _hover={{ shadow: 'lg' }}
                      transition="0.3s"
                    >
                      <HStack justify="space-between" mb={2}>
                        <HStack spacing={2}>
                          <Icon as={EditIcon} />
                          <Text fontSize="sm">
                            By{' '}
                            <Badge colorScheme="green">{note.created_by}</Badge>
                          </Text>
                        </HStack>
                        <HStack spacing={2}>
                          <Icon as={CalendarIcon} />
                          <Text fontSize="sm">
                            {new Date(note.created_at).toLocaleString()}
                          </Text>
                        </HStack>
                      </HStack>

                      <Text mt={1} fontSize="md">
                        {note.content}
                      </Text>

                      <HStack justify="flex-end" mt={3}>
                        <>
                          <Tooltip label="Delete Note" hasArrow>
                            <IconButton
                              aria-label="Delete Note"
                              icon={<DeleteIcon />}
                              size="md"
                              colorScheme="red"
                              variant="ghost"
                              onClick={() => requestDeleteNote(note)}
                              _hover={{ bg: 'red.100' }}
                              _active={{ bg: 'red.200' }}
                            />
                          </Tooltip>
                        </>
                      </HStack>
                    </Box>
                  ))
              )}
            </VStack>
          )}
          </LeadSectionCard>
        </Box>
      </SimpleGrid>

      <AlertDialog
        isOpen={isOpenNoteDelete}
        leastDestructiveRef={noteDeleteCancelRef}
        onClose={() => {
          setNoteToDelete(null);
          onCloseNoteDelete();
        }}
        isCentered
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Delete Note
            </AlertDialogHeader>

            <AlertDialogBody>
              Are you sure you want to delete this note? This action cannot be
              undone.
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button
                ref={noteDeleteCancelRef}
                onClick={() => {
                  setNoteToDelete(null);
                  onCloseNoteDelete();
                }}
              >
                Cancel
              </Button>
              <Button
                colorScheme="red"
                onClick={() => noteToDelete && handleDeleteNote(noteToDelete.id)}
                ml={3}
              >
                Delete
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </LeadShell>
  );
}
